export default __webpack_public_path__ + "static/media/onshare.01e1e987.png";